function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Logo");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  y2: "50%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#6001A5",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#6001A5",
  offset: "33.44%"
}), React.createElement("stop", {
  stopColor: "#DE0877",
  offset: "93.236%"
}), React.createElement("stop", {
  stopColor: "#ED0577",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.234 1114l.003.005c-2.93 0-3.398 1.96-3.452 2.921v21.26l2.074-.002c1.66.034 2.045-1.025 2.063-1.621V1136.4c1.301 1.363 3.09 2.142 5.105 2.142 4.393 0 7.973-3.771 7.973-8.712 0-4.974-3.58-8.744-7.973-8.744-1.92 0-3.644.715-4.914 1.95V1114h-.88zm.88 15.863c0-2.665 1.92-4.81 4.295-4.81s4.295 2.08 4.295 4.81c0 2.666-1.92 4.714-4.295 4.714s-4.296-2.113-4.296-4.714zm-22.608-.032c0 5.006 3.775 8.745 8.428 8.745 4.653 0 8.46-3.739 8.46-8.745 0-5.006-3.807-8.81-8.46-8.81-4.653 0-8.428 3.804-8.428 8.81zm4.295.032c0-2.893 1.855-4.908 4.133-4.908s4.133 2.015 4.133 4.908c0 2.828-1.855 4.779-4.133 4.779s-4.133-1.95-4.133-4.779zm-33.914-6.469c-1.205-1.462-3.06-2.373-5.337-2.373-4.589 0-7.55 3.219-7.55 7.477v9.687h1.4c.951-.058 2.831-.53 2.896-3.305v-6.48c0-1.885 1.334-3.185 3.254-3.185 2.83 0 3.124 2.243 3.124 3.186v9.784h1.4c.949-.058 2.817-.527 2.895-3.274v-6.51c0-1.886 1.367-3.186 3.254-3.186 2.831 0 3.157 2.243 3.157 3.186v9.784h1.397c.958-.058 2.854-.533 2.898-3.349v-6.338c0-4.388-2.766-7.477-7.452-7.477-2.18 0-4.067.91-5.336 2.373zm25.17-.094l-3.61 9.997-3.93-10.351c-.594-1.639-2.146-1.55-2.146-1.55h-3.346l6.658 16.265-.015-.051a13.248 13.248 0 0 0 .05.134l-.035-.083c.219.662.155 1.03-.045 1.668l-.145.412c-.774 1.923-1.864 2.444-4.183 2.314v.014l1.61 3.931c2.98-.065 5.222-1.037 6.72-4.76l8.013-19.842v-.001l-2.996-.002h-.013c-.161 0-1.868.044-2.586 1.905z",
  transform: "rotate(-90 -521.5 592.5)",
  fill: "url(#a)",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 78,
    viewBox: "0 0 32 78"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/logo.ecf250e4.svg";
export { SvgComponent as ReactComponent };